module.exports = __webpack_public_path__ + "mainassets/img/faq-2.197af8a3.svg";